export default "__VITE_ASSET__kn5D1Awj__"